import { type NavigationTreeDataDTO } from "../api/getNavigationTree";
import { Link } from "../../../common/components/Link";
import { Accordion, AccordionDetails, AccordionSummary, Stack } from "~/common/mui";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
  navigation: NavigationTreeDataDTO[];
}

export const NotificationSettingsNavigation = ({ navigation, className }: Props) => {
  const { t } = useTranslation();

  navigation = navigation.filter((parent) => parent.parentType !== "ALL");
  return (
    <div className={className}>
      <Accordion expanded={true}>
        <AccordionSummary expandIcon={null} sx={{ pointerEvents: "none" }}>
          {t("notifications.filters.header.title")}
        </AccordionSummary>
        <AccordionDetails>
          <Stack gap={2}>
            {navigation.map((item, i) => (
              <Link key={i} href={"#" + item.parentType}>
                {t(`${item.parentLabelTranslation}`)}
              </Link>
            ))}
          </Stack>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};
